"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductLine = void 0;
var ProductLine;
(function (ProductLine) {
    ProductLine[ProductLine["PWS"] = 0] = "PWS";
    ProductLine[ProductLine["Schools"] = 1] = "Schools";
    ProductLine[ProductLine["Platform"] = 2] = "Platform";
    ProductLine[ProductLine["Water Testing Kit"] = 3] = "Water Testing Kit";
    ProductLine[ProductLine["Pitcher Filter Kit"] = 4] = "Pitcher Filter Kit";
    ProductLine[ProductLine["Water Sample Testing"] = 5] = "Water Sample Testing";
    ProductLine[ProductLine["Recurring Services"] = 6] = "Recurring Services";
    ProductLine[ProductLine["One Time Services"] = 7] = "One Time Services";
})(ProductLine = exports.ProductLine || (exports.ProductLine = {}));
//# sourceMappingURL=ProductLine.js.map